<div class="dashboard-header">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h5 class="dashboard-title mb-0">Dashboard</h5>
      <div *ngIf="isCompletionFiltered" class="filter-badge-active">
        <span class="filter-tag">
          <i class="fa fa-filter"></i> {{ completionCategoryLabel }}
        </span>
        <button class="filter-clear-btn" (click)="clearCompletionFilter()" title="Clear filter">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="header-actions">
      <button *ngIf="fromSourcePulse" class="icon-btn" (click)="back()" title="Back to Source Pulse">
        <i class="fa fa-arrow-left"></i>
      </button>
      <button class="icon-btn" (click)="refreshPage()" title="Refresh dashboard data">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>
</div>

<!-- Stage Tabs -->
<div class="stage-tabs-bar">
  <ul class="nav nav-tabs tab-nav" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link" [class.active]="activeTab === 1" (click)="setActiveTab(1)">
        <i class="fa fa-dollar-sign tab-icon tab-icon-costing"></i>
        <span>Costing</span>
        <span class="tab-badge tab-badge-costing">{{ costingTotalCount || costingData.length }}</span>
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link tab-link" [class.active]="activeTab === 2" (click)="setActiveTab(2)">
        <i class="fa fa-shopping-cart tab-icon tab-icon-procurement"></i>
        <span>Procurement</span>
        <span class="tab-badge tab-badge-procurement">{{ procurementTotalCount || procurementData.length }}</span>
      </button>
    </li>
  </ul>
</div>

<!-- Filter Bar -->
<div class="filter-bar">
  <div class="filter-bar-left">

    <div class="filter-item position-relative" title="Project Name" style="width: 160px;">
      <input id="projectName" class="filter-input" type="text" placeholder="Search Project"
        [(ngModel)]="selectedProjectName" (input)="filterProjectNames()" (focus)="onProjectFocus()"
        (blur)="hideDropdown()" (keyup.enter)="onProjectEnter()" autocomplete="off" />

      <ul class="list-group position-absolute project-dropdown"
        *ngIf="showProjectDropdown && filteredProjectNames.length > 0">
        <li class="list-group-item list-group-item-action project-dropdown-item"
          *ngFor="let name of filteredProjectNames" (mousedown)="selectProjectName(name)" [title]="name">
          {{ name }}
        </li>
      </ul>
    </div>

    <div class="filter-item filter-item-icon" title="Select Customer">
      <i class="fa fa-building filter-item-prefix-icon"></i>
      <select id="customerName" class="filter-select filter-select-icon" aria-label="Select Customer Name"
        [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
        <option value="">Customer</option>
        <option *ngFor="let cus of allCustomerData" [value]="cus.customerName">{{ cus.customerName }}</option>
      </select>
    </div>
    <!-- <div class="filter-item filter-item-icon" title="Select Stage">
      <i class="fa fa-layer-group filter-item-prefix-icon"></i>
      <select id="stageFilter" class="filter-select filter-select-icon" aria-label="Select Stage"
        [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
        <option disabled value="" [selected]="selectedCurrentStage === ''">Stage</option>
        <option value="Costing">Costing</option>
        <option value="Procurement">Procurement</option>
      </select>
    </div> -->

    <button type="button" class="filter-btn filter-btn-ecd"
      [class.active]="!!(fromExpectedCompletionDate || toExpectedCompletionDate)" (click)="openModalECD()">
      <i class="fa fa-calendar"></i> ECD
    </button>

    <!-- ECD Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
      [ngStyle]="{'display': showModalECD ? 'block' : 'none'}" (click)="closeModalECD()">
      <div class="modal-dialog date-filter-dialog-top" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content date-filter-modal">
          <div class="date-filter-header">
            <div class="date-filter-header-left">
              <div class="date-filter-icon date-filter-icon-ecd">
                <i class="fa fa-calendar-check-o"></i>
              </div>
              <div>
                <div class="date-filter-title">Expected Completion Date</div>
                <div class="date-filter-subtitle">Filter projects by completion date range</div>
              </div>
            </div>
            <button type="button" class="date-filter-close" (click)="closeModalECD()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="date-filter-body">
            <div class="date-filter-fields">
              <div class="date-filter-field">
                <label for="fromExpectedCompletionDate" class="date-filter-label">
                  <i class="fa fa-arrow-right"></i> From
                </label>
                <input id="fromExpectedCompletionDate" class="date-filter-input" type="date"
                  aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                  (change)="onSelectCompletionDate()" />
              </div>
              <div class="date-filter-field">
                <label for="toExpectedCompletionDate" class="date-filter-label">
                  <i class="fa fa-arrow-left"></i> To
                </label>
                <input id="toExpectedCompletionDate" class="date-filter-input" type="date"
                  aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                  (change)="onSelectCompletionDate()" />
              </div>
            </div>
          </div>
          <div class="date-filter-footer">
            <button type="button" class="date-filter-btn-reset" (click)="resetDates()">
              <i class="fa fa-undo"></i> Reset
            </button>
            <button type="button" class="date-filter-btn-apply" (click)="closeModalECD()">
              <i class="fa fa-check"></i> Apply
            </button>
            <button type="button" class="date-filter-btn-close" (click)="closeModalECD()">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>



    <button type="button" class="filter-btn filter-btn-rfq" [class.active]="!!(fromRfqDate || toRfqDate)"
      (click)="openModalRFQ()">
      <i class="fa fa-calendar"></i> RFQ
    </button>

    <!-- RFQ Date Range Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
      [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}" (click)="closeModalRFQ()">
      <div class="modal-dialog date-filter-dialog-top" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content date-filter-modal">
          <div class="date-filter-header">
            <div class="date-filter-header-left">
              <div class="date-filter-icon date-filter-icon-rfq">
                <i class="fa fa-calendar"></i>
              </div>
              <div>
                <div class="date-filter-title">RFQ Date</div>
                <div class="date-filter-subtitle">Filter projects by RFQ date range</div>
              </div>
            </div>
            <button type="button" class="date-filter-close" (click)="closeModalRFQ()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="date-filter-body">
            <div class="date-filter-fields">
              <div class="date-filter-field">
                <label for="fromRfqDate" class="date-filter-label">
                  <i class="fa fa-arrow-right"></i> From
                </label>
                <input id="fromRfqDate" class="date-filter-input" type="date" aria-label="Select From RFQ Date"
                  [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
              </div>
              <div class="date-filter-field">
                <label for="toRfqDate" class="date-filter-label">
                  <i class="fa fa-arrow-left"></i> To
                </label>
                <input id="toRfqDate" class="date-filter-input" type="date" aria-label="Select To RFQ Date"
                  [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
              </div>
            </div>
          </div>
          <div class="date-filter-footer">
            <button type="button" class="date-filter-btn-reset" (click)="resetRfqDates()">
              <i class="fa fa-undo"></i> Reset
            </button>
            <button type="button" class="date-filter-btn-apply" (click)="closeModalRFQ()">
              <i class="fa fa-check"></i> Apply
            </button>
            <button type="button" class="date-filter-btn-close" (click)="closeModalRFQ()">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="filter-btn filter-btn-reset" title="Reset fields" (click)="resetFields()">
      <i class="fa fa-undo"></i> Reset
    </button>
  </div>
  <div class="filter-bar-right">
    <button type="button" class="action-btn" title="Create New Project"
      (click)="openProjectModel(projectModal, null, null)">
      <i class="fa fa-plus"></i> Add Project
    </button>
    <button type="button" class="source-pulse-btn" title="Analysis" (click)="onClickAnalysis()">
      <i class="fa fa-line-chart"></i> Source Pulse
    </button>
  </div>
</div>

<!-- Stat Cards -->
<div class="stat-cards-row">
  <div class="stat-card stat-card-open" (click)="onOpenClickedProject('Open')">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{openStatusCount}}</div>
        <div class="stat-card-label">Open Projects</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-folder-open"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-overdue" (click)="onOverdueClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{overdueCount}}</div>
        <div class="stat-card-label">Over Due</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-clock"></i>
      </div>
    </div>
  </div>

  <div class="stat-card stat-card-month" (click)="onThisMonthClick()">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">{{ thisMonthProjects?.length || 0 }}</div>
        <div class="stat-card-label">This Month</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-calendar"></i>
      </div>
    </div>
  </div>

  <!-- <div class="stat-card stat-card-risk">
    <div class="stat-card-body">
      <div class="stat-card-info">
        <div class="stat-card-number">10</div>
        <div class="stat-card-label">High Risk Parts</div>
      </div>
      <div class="stat-card-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
    </div>
  </div> -->
</div>

<div *ngIf="loading" class="sb-in-progress-card my-4" style="background: #ffffff; border: 1px dashed #cbd5e1; border-radius: 16px; padding: 36px 20px; display: flex; flex-direction: column; align-items: center; text-align: center;">
  <div class="sb-spinner-container mb-3" style="width: 56px; height: 56px; position: relative; display: flex; align-items: center; justify-content: center;">
    <div class="sb-spinner-ring"></div>
    <div class="sb-spinner-ring-inner"></div>
    <div class="sb-spinner-core" style="width: 30px; height: 30px;">
      <i class="fa fa-folder-open sb-spinner-icon" style="font-size: 13px;"></i>
    </div>
  </div>
  <h5 class="sb-loading-title" style="font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 4px;">Loading Projects</h5>
  <p class="sb-loading-subtitle" style="font-size: 13px; color: #64748b; margin-bottom: 14px;">Fetching assigned projects, versions, and current stage status...</p>
  <div class="sb-loading-progress-bar">
    <div class="sb-loading-progress-indeterminate"></div>
  </div>
</div>

<div *ngIf="!loading && matchedCustomerData.length === 0" class="empty-state">
  <i class="fa fa-inbox"></i>
  <p>No data found.</p>
</div>

<!-- Approval Modal Popup -->
<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showApprovalModal}"
  [ngStyle]="{'display': showApprovalModal ? 'block' : 'none'}">
  <div class="modal-dialog" role="document" style="max-width: 500px;">
    <div class="modal-content date-filter-modal">
      <div class="date-filter-header">
        <div class="date-filter-header-left">
          <div class="date-filter-icon" style="background: linear-gradient(135deg, #10b981, #059669);">
            <i class="fa fa-check-circle"></i>
          </div>
          <div>
            <div class="date-filter-title">Approval Status</div>
            <div class="date-filter-subtitle">{{ selectedApprovalProject?.approval_status }}</div>
          </div>
        </div>
        <button type="button" class="date-filter-close" (click)="closeApprovalModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="date-filter-body">
        <div style="margin-bottom: 12px;">
          <label style="font-weight: 600; color: #475569; margin-bottom: 8px; display: block;">Project Details</label>
          <div
            style="background: #f8fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 12px;">
            <p style="margin: 4px 0; font-size: 13px;"><strong>Project:</strong> {{ selectedApprovalProject?.projectName
              }}</p>
            <p style="margin: 4px 0; font-size: 13px;"><strong>Version:</strong> {{ selectedApprovalProject?.version_id
              }}</p>
            <p style="margin: 4px 0; font-size: 13px;"><strong>Status:</strong> {{
              selectedApprovalProject?.approval_status }}</p>
          </div>

          <label for="approvalStatusSelect"
            style="font-weight: 600; color: #475569; margin-bottom: 8px; display: block;">Approval Status</label>
          <select id="approvalStatusSelect" class="form-control" [(ngModel)]="selectedApprovalStatus"
            style="border-radius: 6px; border: 1px solid #cbd5e1; padding: 8px; width: 100%;">
            <option value="Pending - Manager Review">Pending - Manager Review</option>
          </select>
        </div>
      </div>

      <div class="date-filter-footer">
        <button type="button" class="date-filter-btn-close" (click)="closeApprovalModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="button" class="addBtn" style="padding: 8px 16px; margin-left: 8px;"
          (click)="submitApprovalRequest()">
          <i class="fa fa-send"></i> Send Approval
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="table-card">
      <!-- Tab Content -->
      <div class="card-body">

        <!-- Pagination Controls -->
        <div class="pagination-controls">
          <!-- Left: Rows per page selector -->
          <div class="pagination-left">
            <div class="page-size-selector">
              <span class="pagination-label">Show</span>
              <select id="rowsPerPage" class="rows-per-page" [(ngModel)]="rowsPerPage" (change)="onPageSizeChange()">
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
              </select>
              <span class="pagination-label">entries</span>
            </div>
          </div>

          <!-- Right: Row Count Badge, Page Navigation & Jump -->
          <div class="pagination-right">
            <div class="row-count-badge">
              <i class="fa fa-list-ol" style="color: #0284c7; font-size: 11px;"></i>
              <span>Showing <strong>{{ getTotalCountForTab() > 0 ? getStartIndexForTab() : 0 }}</strong> - <strong>{{
                  getEndIndexForTab() }}</strong> of <strong>{{ getTotalCountForTab() }}</strong> rows</span>
            </div>

            <div class="pagination-nav">
              <button type="button" class="pagination-btn" (click)="firstPage()" [disabled]="currentPage === 1"
                title="First Page">
                <i class="fa fa-angle-double-left"></i>
              </button>
              <button type="button" class="pagination-btn" (click)="previousPage()" [disabled]="currentPage === 1"
                title="Previous Page">
                <i class="fa fa-chevron-left"></i>
              </button>

              <!-- Numbered Page Pills -->
              <div class="pagination-pages-list">
                <ng-container *ngFor="let p of getVisiblePages(); let i = index">
                  <button *ngIf="p !== '...'" type="button" class="pagination-num-btn"
                    [class.active]="p === currentPage" (click)="goToPage(p)">
                    {{ p }}
                  </button>
                  <button *ngIf="p === '...'" type="button" class="pagination-num-btn pagination-ellipsis-btn"
                    (click)="jumpByPages(i === 1 ? -5 : 5)"
                    [title]="i === 1 ? 'Jump back 5 pages' : 'Jump forward 5 pages'">
                    &hellip;
                  </button>
                </ng-container>
              </div>

              <button type="button" class="pagination-btn" (click)="nextPage()"
                [disabled]="currentPage >= getTotalPagesForTab() || getTotalPagesForTab() === 0" title="Next Page">
                <i class="fa fa-chevron-right"></i>
              </button>
              <button type="button" class="pagination-btn" (click)="lastPage()"
                [disabled]="currentPage >= getTotalPagesForTab() || getTotalPagesForTab() === 0" title="Last Page">
                <i class="fa fa-angle-double-right"></i>
              </button>
            </div>

            <!-- Quick Page Jump -->
            <div class="pagination-jump" *ngIf="getTotalPagesForTab() > 1">
              <span class="jump-label">Go to</span>
              <input type="number" class="jump-input" [(ngModel)]="jumpPageInput" (keyup.enter)="jumpToPage()" min="1"
                [max]="getTotalPagesForTab()" placeholder="#" />
              <button type="button" class="jump-btn" (click)="jumpToPage()" title="Go to page">
                <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Project Name</th>
                <th>Customer Name</th>
                <th>RFQ Date</th>
                <th>Assigned Date</th>
                <th>E.C.Date</th>
                <th class="text-center">Target L.Time(W)</th>
                <th class="text-center">Ageing</th>
                <th>Progress</th>
                <th>Upload Status</th>
                <th>Approval Status</th>
                <th>Project Status</th>
                <!-- <th>Current Stage</th> -->
                <th>Version</th>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let group of paginatedData; let i = index; trackBy: trackByCustomer"
                [ngClass]="{'highlighted-row': group?.project_id === highlightedProjectId}">
                <td (click)="onRowSelect(group)">{{ getStartIndexForTab() + i }}</td>
                <td (click)="onRowSelect(group)" title="{{ group?.projectName }}">{{ group?.projectName }}</td>
                <td (click)="onRowSelect(group)" title="{{ group?.customer_name }}">{{ group?.customer_name }}
                </td>
                <td (click)="onRowSelect(group)" class="td_date" title="{{ group?.rfqDate | date: 'dd-MM-yyyy' }}">{{
                  group?.rfqDate | date: 'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(group)" class="td_date"
                  title="{{ group?.assigned_date | date: 'dd-MM-yyyy' }}">{{ group?.assigned_date | date:
                  'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(group)" class="td_date"
                  title="{{ group?.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}">{{
                  group?.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}</td>
                <td class="text-center" (click)="onRowSelect(group)" title="{{ group?.targetLeadTime }}">{{
                  group?.targetLeadTime
                  }}</td>
                <td class="text-center" (click)="onRowSelect(group)"
                  [title]="calculateAgeing(group?.assigned_date, group?.status, group?.closed_date)"
                  [ngStyle]="{'color': (group.selectedVersionData?.status === 'Open' && isECDGreaterThanToday(group.selectedVersionData?.expectedCompletionDate)) ? 'red' : 'inherit'}">
                  {{ calculateAgeing(group?.assigned_date, group?.status, group?.closed_date) }}
                </td>

                <td>
                  <div class="progress-container" (click)="onRowSelect(group)">
                    <div
                      style="width: 80%; height: 16px; background-color: #f5f5f5; position: relative; border-radius: 10px; overflow: hidden; border: 1px solid #e0e0e0;">

                      <!-- Progress text -->
                      <div
                        style="position: absolute; z-index: 10; width: 100%; text-align: center; font-size: 12px; color: #424242; font-weight: 600; margin-top: -1px; line-height: 16px;">
                        {{ group.selectedVersionData?.progress }}
                      </div>

                      <!-- Progress bar -->
                      <div [ngStyle]="{
          'width': group.selectedVersionData?.progress,
          'height': '100%',
          'background-color': getProgressColor(group.selectedVersionData?.progress),
          'border-radius': '10px',
          'transition': 'width 0.3s ease'
        }">
                      </div>

                    </div>
                  </div>
                </td>



                <td *ngIf="!group.selectedVersionData?.newVersion">
                  <ng-container *ngIf="(group.selectedVersionData?.upload_status?.toLowerCase() === 'error' || group.selectedVersionData?.upload_status?.toLowerCase() === 'new') && 
                           (activeTab === 1 && group.selectedVersionData?.version_id === 1); else statusText">
                    <button type="button" class="btn btn-primary btn-sm ml-1 addBtn" title="Add Sourcing List"
                      (click)="uploadSourcingList(uploadFileModal, group.selectedVersionData, group)">
                      +
                    </button>
                  </ng-container>

                  <ng-template #statusText>
                    <span class="upload-status-text" title="{{group.selectedVersionData?.upload_status}}">
                      {{ (group.selectedVersionData?.upload_status === 'NoPartsFound' ||
                      group.selectedVersionData?.upload_status === 'PartialSuccess') ? 'Completed' :
                      group.selectedVersionData?.upload_status }}
                    </span>
                  </ng-template>

                </td>
                <td *ngIf="group.selectedVersionData?.newVersion" (click)="onRowSelect(group)"
                  title="{{group.selectedVersionData?.newVersion}}">In
                  Progress </td>

                <!-- Approval Status Column -->
                <td>
                  <span class="approval-status-text" [ngStyle]="{'cursor': 'pointer', 'color': '#3b82f6'}"
                    (click)="openApprovalModal(group)"
                    title="{{group.selectedVersionData?.approval_status || 'No Status'}}">
                    {{ group.selectedVersionData?.approval_status || '-' }}
                  </span>
                </td>

                <!-- <td (click)="onRowSelect(group)" title="{{group?.selectedVersionData?.currentstage}}">
                  <span [ngStyle]="{
    'color': group.selectedVersionData?.currentstage === 'Costing' ? '#1e90ff' : 
              group.selectedVersionData?.currentstage === 'Procurement' ? '#ff4500' : 'inherit'
  }">
                    {{ group?.selectedVersionData?.currentstage }}
                  </span>
                </td> -->
                <td>
                  <span [ngStyle]="{
    'color': (group.selectedVersionData?.status === 'Open') ? '#FFA500' : 
             (group.selectedVersionData?.status === 'Closed') ? '#e23328' : 'inherit'
  }">
                    {{ group.selectedVersionData?.status }}
                  </span>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <!-- Costing Tab: Show version_id -->
                    <ng-container *ngIf="activeTab === 1">
                      <ng-container *ngIf="!group.selectedVersionData?.isAddingNewVersion">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.version_id" (change)="onVersionChange($event, group)"
                          title="Version number">
                          <option *ngFor="let version_id of group.versions" [value]="version_id">
                            {{ version_id }}
                          </option>
                        </select>

                        <button *ngIf="!isRestrictedStatus(group.selectedVersionData?.approval_status)" type="button"
                          class="btn btn-sm btn-primary addBtn ms-1"
                          (click)="openVersionChoicePopup(versionChoiceModal, group.selectedVersionData)"
                          title="Add new version number">
                          +
                        </button>

                      </ng-container>
                      <ng-container *ngIf="group.selectedVersionData?.isAddingNewVersion">
                        <input type="number" class="form-control form-control-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.newVersion" readonly />
                        <button type="button" class="btn btn-sm btn-primary addBtn"
                          (click)="saveNewVersion(group.selectedVersionData)">✔</button>
                        <button type="button" class="btn btn-sm btn-danger"
                          (click)="cancelNewVersion(group.selectedVersionData)">✖</button>
                      </ng-container>
                    </ng-container>

                    <!-- Procurement Tab: Show procurement versions -->
                    <ng-container *ngIf="activeTab === 2">
                      <ng-container *ngIf="!group.selectedVersionData?.isAddingNewVersion">
                        <select class="form-select form-select-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.procurement_version_id"
                          (change)="onProcurementVersionChange($event, group)" title="Procurement Version number">
                          <option *ngFor="let procVersion of group.procurementVersions" [value]="procVersion">
                            {{ procVersion }}
                          </option>
                        </select>
                        <button *ngIf="!isRestrictedStatus(group.selectedVersionData?.approval_status)" type="button"
                          class="btn btn-sm btn-primary addBtn ms-1"
                          (click)="openVersionChoicePopup(versionChoiceModal, group.selectedVersionData)"
                          title="Add new procurement version">
                          +
                        </button>

                      </ng-container>
                      <ng-container *ngIf="group.selectedVersionData?.isAddingNewVersion">
                        <input type="number" class="form-control form-control-sm version-dropdown"
                          [(ngModel)]="group.selectedVersionData.newVersion" readonly />
                        <button type="button" class="btn btn-sm btn-primary addBtn"
                          (click)="saveNewVersion(group.selectedVersionData)">✔</button>
                        <button type="button" class="btn btn-sm btn-danger"
                          (click)="cancelNewVersion(group.selectedVersionData)">✖</button>
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div *ngIf="paginatedData.length === 0 && currentTabData.length === 0" class="tab-empty-state">
          <i class="fa fa-info-circle"></i>
          <span>No projects found in the {{ activeTab === 1 ? 'Costing' : 'Procurement' }} stage.</span>
        </div>

        <ng-template #versionChoiceModal let-modal>
          <div class="modal-header d-flex align-items-center justify-content-between gap-3">
            <div>
              <h6 class="modal-title mb-0">Duplicate Version Creation</h6>
              <!-- <small class="text-muted">Confirm how you want to update the current version.</small> -->
            </div>
            <button type="button" class="close" (click)="modal.dismiss()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center py-4">
            <p class="mb-2 fw-semibold">Do you really want to clone the version ?

            </p>
            <p class="mb-4 text-muted small">Note : Use cloning to duplicate the current version before making changes
              to ensure no data is lost.
            </p>

            <div class="d-flex justify-content-center flex-wrap" style="gap: 40px;">
              <button class="btn btn-outline-primary btn-sm px-4 me-2" (click)="chooseNewVersion(); modal.close()">
                Create
              </button>
              <button type="button" class="btn btn-outline-secondary btn-sm px-4" (click)="modal.dismiss()">
                Cancel
              </button>
            </div>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>

<div *ngIf="sourceListData.length > 0 || avdData.length > 0">
  <div *ngIf="matchedCustomerData.length > 0">
    <div class="row row_mar mt-1" *ngIf="finalDataList.length === 0">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Sourcing List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th>Customer Part Number</th>
                    <th>Internal Part Number</th>
                    <th>Description</th>
                    <th>Specification</th>
                    <th>Commodity</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>UOM</th>
                    <th>Project Quantity</th>
                    <th>I-Sourcing</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of sourceListData">
                    <td>{{ item.SlNo }}</td>
                    <td>{{ item.customerPartNumber }}</td>
                    <td>{{ item.internalPartNo }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.specification }}</td>
                    <td>{{ item.commodity }}</td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.uom }}</td>
                    <td>{{ item.projectQty }}</td>
                    <td>{{ item.iSourcing }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="finalDataList.length === 0" class="row row_mar mt-1">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Alternate Vendor List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Internal Part No.</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>Specification</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let avditem of avdData">
                    <td>{{ avditem.internalPartNo }}</td>
                    <td>{{ avditem.manufacturer }}</td>
                    <td>{{ avditem.specification }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="finalDataList.length > 0" class="row row_mar">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <h6 class="card-title">Preview</h6>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-light btn-sm" title="Export as Excel" (click)="exportData()">
            <i class="fas fa-file-export"></i> Export
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="resetFinalData()">Reset</button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="selectCriteria(criteriaModal)">Criteria</button>

          <button type="button" class="btn btn-outline-primary btn-sm" title="Upload data" [disabled]="!isUploadEnabled"
            (click)="uploadFinalData()">
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Upload
          </button>
        </div>
      </div>



      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">

          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th *ngFor="let col of tableHeaders; let i = index">
                  {{ col.label }}
                  <i class="fa fa-chevron-down" (click)="toggleSearch(i)"></i> <!-- Font Awesome Icon -->
                </th>
              </tr>
              <tr *ngIf="showSearch">
                <th *ngFor="let col of tableHeaders; let i = index">
                  <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                    [(ngModel)]="searchValues[i]" (input)="filterData(searchValues[i])"
                    placeholder="Search {{ col.label }}" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of finalDataList; let i=index"
                [ngClass]="{'not-matched-row': item.showInPayload === false}">
                <td>{{ i+1 }}</td>
                <td> {{ !!item?.customerPartNumber ? item?.customerPartNumber : item?.customerPartNo }}</td>
                <td>{{ item?.internalPartNo }}</td>
                <td>{{ item?.description }}</td>
                <td>{{ item?.specification }}</td>
                <td>{{ item?.commodity }}</td>
                <!-- <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i); onPreviewManufacturerClick(i)">
                      <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]"
                      class="form-select form-select-sm manufacturer-dropdown drop-7rem"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td> -->

                <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i)">
                      <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]"
                      class="form-select form-select-sm manufacturer-dropdown drop-7rem"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td>
                <td *ngIf="!item?.manufacturer">-</td>

                <td>{{ item?.uom }}</td>
                <td>{{ item?.projectQty }}</td>
                <td>
                  <span [style.color]="item?.eol_status === 'Active' ? '#16a34a' : '#dc2626'"
                    style="font-weight: 600; cursor: pointer; text-decoration: underline;"
                    (click)="openMpnAlternativesModal(i)" title="Click to view alternatives">
                    <span *ngIf="mpnCheckLoading[i]" class="spinner-border spinner-border-sm" role="status"></span>
                    {{ item?.eol_status || '-' }}
                  </span>
                </td>
                <td>{{ item?.eol_confidence }}</td>
                <td>{{ item?.iSourcing }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #customerModal let-modal>
  <div class="cust-modal-wrapper">
    <form [formGroup]="customerForm">

      <!-- Header -->
      <div class="cust-modal-header">
        <div class="cust-modal-header-left">
          <div class="cust-modal-icon">
            <i class="fa fa-user-plus"></i>
          </div>
          <div>
            <h5 class="cust-modal-title">Add Customer</h5>
            <p class="cust-modal-subtitle">Enter the new customer's details</p>
          </div>
        </div>
        <button type="button" class="cust-modal-close" (click)="closeCustomerModal()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="cust-modal-body">

        <!-- Row 1: Full Name + City -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="_customerFullName">
              <i class="fa fa-id-card proj-label-icon"></i> Customer Full Name
            </label>
            <input type="text" id="_customerFullName" class="proj-field-input" placeholder="Enter full name"
              formControlName="_customerFullName" (keyup)="onEnterCustomerName($event)" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('_customerFullName')?.touched && customerForm.get('_customerFullName')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Full Name is required (min 2 characters)
            </div>
            <div class="proj-field-error" *ngIf="isCustomerNameDuplicate">
              <i class="fa fa-exclamation-circle"></i> Customer already exists. Choose a different name.
            </div>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="city">
              <i class="fa fa-map-marker proj-label-icon"></i> City
            </label>
            <input type="text" id="city" class="proj-field-input" placeholder="Enter city" formControlName="city" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('city')?.touched && customerForm.get('city')?.invalid">
              <i class="fa fa-exclamation-circle"></i> City is required
            </div>
          </div>
        </div>

        <!-- Row 2: State + Country -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="state">
              <i class="fa fa-map proj-label-icon"></i> State
            </label>
            <input type="text" id="state" class="proj-field-input" placeholder="Enter state" formControlName="state" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('state')?.touched && customerForm.get('state')?.invalid">
              <i class="fa fa-exclamation-circle"></i> State is required
            </div>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="country">
              <i class="fa fa-globe proj-label-icon"></i> Country
            </label>
            <input type="text" id="country" class="proj-field-input" placeholder="Enter country"
              formControlName="country" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('country')?.touched && customerForm.get('country')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Country is required
            </div>
          </div>
        </div>

        <!-- Row 3: GST Number -->
        <div class="proj-form-grid cust-single-col">
          <div class="proj-form-field">
            <label class="proj-field-label" for="gstNumber">
              <i class="fa fa-file-text proj-label-icon"></i> GST Number
            </label>
            <input type="text" id="gstNumber" class="proj-field-input" placeholder="Enter 15-digit GST number"
              formControlName="gstNumber" />
            <div class="proj-field-error"
              *ngIf="customerForm.get('gstNumber')?.touched && customerForm.get('gstNumber')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Enter a valid 15-digit GST Number
            </div>
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="proj-modal-footer">
        <button type="button" class="proj-btn-secondary" title="Close" (click)="closeCustomerModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="button" class="proj-btn-primary" [disabled]="isCustomerNameDuplicate" title="Save customer"
          (click)="saveCustomer()">
          <i class="fa fa-check"></i> Save Customer
        </button>
      </div>

    </form>
  </div>
</ng-template>

<ng-template #projectModal let-modal>
  <div class="proj-modal-wrapper">
    <form [formGroup]="projectForm">

      <!-- Modal Header -->
      <div class="proj-modal-header">
        <div class="proj-modal-header-left">
          <div class="proj-modal-icon">
            <i class="fa fa-folder-open"></i>
          </div>
          <div>
            <h5 class="proj-modal-title">Add / Modify Project</h5>
            <p class="proj-modal-subtitle">Fill in the project details below</p>
          </div>
        </div>
        <button type="button" class="proj-modal-close" (click)="closeModal()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="proj-modal-body">

        <!-- Row 1: Project No + Customer Name -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="newProjectName">
              <i class="fa fa-hashtag proj-label-icon"></i> Project No
            </label>
            <input type="text" id="newProjectName" class="proj-field-input" formControlName="newProjectName"
              (keyup)="enterProject($event)" placeholder="Enter project number" />
            <div class="proj-field-error" *ngIf="isProjectNameDuplicate">
              <i class="fa fa-exclamation-circle"></i> Project already exists. Choose a different number.
            </div>
          </div>

          <div class="proj-form-field" style="position: relative;">
            <label class="proj-field-label">
              <i class="fa fa-building proj-label-icon"></i> Customer Name <span class="text-danger">*</span>
            </label>
            <div class="proj-customer-row">
              <ng-select class="proj-ng-select" [items]="allCustomerDetails" bindLabel="customerName"
                bindValue="customerName" [searchable]="true" [clearable]="true" [closeOnSelect]="true"
                [placeholder]="projectForm.get('customerFullName')?.value ? '' : 'Search or select customer...'"
                (search)="onCustomerSearch($event)" (change)="onAddNewCustomer($event)" (clear)="onCustomerClear()"
                formControlName="customerFullName">

                <!-- Template when an item is selected -->
                <ng-template ng-label-tmp let-item="item">
                  <div class="proj-selected-customer" [title]="item.customerName || item">
                    <i class="fa fa-building proj-customer-icon"></i>
                    <span class="proj-customer-text">{{ item.customerName || item }}</span>
                  </div>
                </ng-template>

                <!-- Template for dropdown options -->
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="proj-option-item">
                    <div class="proj-option-icon">
                      <i class="fa fa-building-o"></i>
                    </div>
                    <div class="proj-option-content">
                      <span class="proj-option-title">{{ item.customerName }}</span>
                      <span class="proj-option-sub" *ngIf="item.customer_id || item.id">ID: #{{ item.customer_id ||
                        item.id }}</span>
                    </div>
                    <span class="proj-option-badge"
                      *ngIf="projectForm.get('customerFullName')?.value === item.customerName">
                      <i class="fa fa-check"></i>
                    </span>
                  </div>
                </ng-template>

                <!-- Template when no option matches -->
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="proj-not-found-box">
                    <div class="proj-not-found-text">
                      <i class="fa fa-search"></i>
                      <span>No customer found matching "<strong>{{ searchTerm }}</strong>"</span>
                    </div>
                    <button type="button" class="proj-create-inline-btn"
                      (click)="openCustomerModel(customerModal, searchTerm)">
                      <i class="fa fa-user-plus"></i> Create Customer "{{ searchTerm }}"
                    </button>
                  </div>
                </ng-template>
              </ng-select>

              <button class="proj-add-customer-btn" [class.proj-add-pulse]="showAddButton"
                (click)="openCustomerModel(customerModal)"
                [title]="showAddButton ? 'Add customer: ' + searchText : 'Create new customer'" type="button">
                <i class="fa fa-user-plus"></i>
              </button>
            </div>
            <div class="proj-field-error"
              *ngIf="projectForm.get('customerFullName')?.touched && projectForm.get('customerFullName')?.invalid">
              <i class="fa fa-exclamation-circle"></i> Customer Name is required
            </div>
          </div>
        </div>

        <!-- Row 2: RFQ Date + Expected Completion Date -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="rfqDate">
              <i class="fa fa-calendar proj-label-icon"></i> RFQ Date
            </label>
            <input type="date" id="rfqDate" class="proj-field-input" formControlName="rfqDate" [max]='maxToday'
              (change)="updateRfqDate()" />
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="completionDate">
              <i class="fa fa-calendar-check-o proj-label-icon"></i> Expected Completion Date
            </label>
            <input type="date" id="completionDate" class="proj-field-input" formControlName="completionDate"
              [min]="nextMaxDate" [disabled]="isExpectedCompletionDateDisabled" (change)="updatecompletionDate()" />
          </div>
        </div>

        <!-- Row 3: Target Lead Time + Assign To -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label">
              <i class="fa fa-clock-o proj-label-icon"></i> Target Lead Time (Weeks)
            </label>
            <input type="number" class="proj-field-input" formControlName="targetLT"
              placeholder="Enter number of weeks" />
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label" for="assignTo">
              <i class="fa fa-user proj-label-icon"></i> Assign To
            </label>
            <select id="assignTo" name="assignTo" class="proj-field-select" formControlName="assignTo" required>
              <option [ngValue]="null" disabled selected>Select engineer</option>
              <option *ngFor="let user of engineersData" [value]="user.engineer_id">{{ user.engineer_name }}</option>
            </select>
          </div>
        </div>

        <!-- Row 4: Current Stage + Version -->
        <div class="proj-form-grid">
          <div class="proj-form-field">
            <label class="proj-field-label" for="currentStage">
              <i class="fa fa-tasks proj-label-icon"></i> Current Stage
            </label>
            <select id="currentStage" name="currentStage" class="proj-field-select" formControlName="currentStage"
              required>
              <option disabled selected [ngValue]="null">Select Stage</option>
              <option value="Costing">Costing</option>
              <option value="Procurement">Procurement</option>
            </select>
          </div>
          <div class="proj-form-field">
            <label class="proj-field-label">
              <i class="fa fa-code-fork proj-label-icon"></i> Version
            </label>
            <input type="number" class="proj-field-input" formControlName="version_id" placeholder="e.g. 1" />
          </div>
        </div>

        <!-- Landing Cost -->
        <div class="proj-landing-row">
          <button type="button" class="proj-landing-btn" title="Configure landing cost"
            (click)="onLandinCost(landinCostModal)">
            <i class="fa fa-calculator"></i> Landing Cost
          </button>
        </div>

      </div>

      <!-- Modal Footer -->
      <div class="proj-modal-footer">
        <button type="button" class="proj-btn-secondary" title="Close" (click)="closeModal()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button type="submit" class="proj-btn-primary" [disabled]="isProjectNameDuplicate" (click)="save()"
          title="Save project">
          <i class="fa fa-check"></i> Save Project
        </button>
      </div>

    </form>
  </div>
</ng-template>

<ng-template #landinCostModal let-modal>
  <div class="lc-modal-wrapper">

    <!-- Header -->
    <div class="lc-modal-header">
      <div class="lc-modal-header-left">
        <div class="lc-modal-icon">
          <i class="fa fa-calculator"></i>
        </div>
        <div>
          <h5 class="lc-modal-title">Landing Cost</h5>
          <p class="lc-modal-subtitle">Configure landing cost for this project</p>
        </div>
      </div>
      <button type="button" class="lc-modal-close" (click)="closeLandingCost(modal)" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="lc-modal-body">

      <!-- Q1 -->
      <div class="lc-question-card">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q1</span>
          <span class="lc-question-text">Do you want to calculate Landing Cost for this project?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q1 === true">
            <input type="radio" name="q1" [checked]="onQn123?.q1 === true" (click)="onQn1Change('yes')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q1 === false">
            <input type="radio" name="q1" [checked]="onQn123?.q1 === false" (click)="onQn1Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Q2 -->
      <div class="lc-question-card" *ngIf="showQn2">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q2</span>
          <span class="lc-question-text">Do you want to consider Duties for calculating landing cost?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q2 === true">
            <input type="radio" name="q2" [checked]="onQn123?.q2 === true" (click)="onQn2Change('yes')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q2 === false">
            <input type="radio" name="q2" [checked]="onQn123?.q2 === false" (click)="onQn2Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Q3 -->
      <div class="lc-question-card" *ngIf="showQn3">
        <div class="lc-question-header">
          <span class="lc-question-badge">Q3</span>
          <span class="lc-question-text">Do you want to adjust duty value?</span>
        </div>
        <div class="lc-radio-group">
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q3 === true">
            <input type="radio" name="q3" [checked]="onQn123?.q3 === true" (click)="onQn3Change('export')">
            <span class="lc-radio-dot"></span>
            <span>Yes</span>
          </label>
          <label class="lc-radio-option" [class.lc-radio-selected]="onQn123?.q3 === false">
            <input type="radio" name="q3" [checked]="onQn123?.q3 === false" (click)="onQn3Change('no', modal)">
            <span class="lc-radio-dot"></span>
            <span>No</span>
          </label>
        </div>
        <div class="lc-duty-input-row" *ngIf="showDutyInput">
          <label class="lc-duty-label"><i class="fa fa-percent"></i> Generic Duty Percentage</label>
          <input type="number" class="lc-duty-input" placeholder="e.g. 18" [(ngModel)]="dutyValuePercentage" />
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="lc-modal-footer">
      <button type="button" class="proj-btn-secondary" title="Close" (click)="closeLandingCost(modal)">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="button" class="proj-btn-primary" title="Save" (click)="saveLandingCost(modal)">
        <i class="fa fa-check"></i> Save
      </button>
    </div>

  </div>
</ng-template>

<ng-template #uploadFileModal let-modal>
  <div class="upload-modal-container">
    <!-- Header: Sky Blue Modern Gradient -->
    <div class="upload-modal-header">
      <div class="upload-modal-header-left">
        <div class="upload-modal-icon-wrapper">
          <i class="fa-solid fa-cloud-arrow-up"></i>
        </div>
        <div class="upload-modal-header-text">
          <div class="d-flex align-items-center flex-wrap" style="gap: 10px;">
            <h5 class="upload-modal-title">Upload Project Files</h5>
            <div *ngIf="selectedProjectName" class="upload-project-pill" title="Current Active Project">
              <i class="fa-solid fa-folder-open"></i>
              <span class="proj-name-text">{{ selectedProjectName }}</span>
              <span class="proj-version-tag">v{{ selectedVersionId || 1 }}</span>
            </div>
          </div>
          <p class="upload-modal-subtitle">Import your sourcing BOM list and alternate vendor data for automated
            analysis &amp; comparison</p>
        </div>
      </div>
      <button type="button" class="upload-modal-close" aria-label="Close" (click)="closeUploadModal()"
        title="Close popup">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Sleek Workflow Progress Strip -->
    <div class="upload-stepper-strip">
      <div class="step-item" [class.step-completed]="sourcingListFileName" [class.step-active]="!sourcingListFileName">
        <div class="step-indicator">
          <i *ngIf="sourcingListFileName" class="fa-solid fa-circle-check"></i>
          <span *ngIf="!sourcingListFileName">1</span>
        </div>
        <div class="step-info">
          <span class="step-name">Sourcing BOM</span>
          <span class="step-status">{{ sourcingListFileName ? 'File Ready' : 'Required (.xlsx)' }}</span>
        </div>
      </div>

      <div class="step-connector" [class.active]="sourcingListFileName"></div>

      <div class="step-item" [class.step-completed]="alternatePartFileName"
        [class.step-active]="sourcingListFileName && !alternatePartFileName">
        <div class="step-indicator">
          <i *ngIf="alternatePartFileName" class="fa-solid fa-circle-check"></i>
          <span *ngIf="!alternatePartFileName">2</span>
        </div>
        <div class="step-info">
          <span class="step-name">Alternate Vendor Data</span>
          <span class="step-status">{{ alternatePartFileName ? 'File Ready' : 'Optional (.pdf, .xlsx)' }}</span>
        </div>
      </div>

      <div class="step-connector" [class.active]="sourcingListFileName && alternatePartFileName"></div>

      <div class="step-item" [class.step-active]="sourcingListFileName || alternatePartFileName">
        <div class="step-indicator">
          <span>3</span>
        </div>
        <div class="step-info">
          <span class="step-name">Compare &amp; Sourcing</span>
          <span class="step-status">Automated Matching</span>
        </div>
      </div>
    </div>

    <!-- Error / Mapping Warning Banner -->
    <div *ngIf="headerErrorMessage" class="upload-modal-error-banner">
      <div class="upload-modal-error-content">
        <div class="error-icon-badge">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div class="error-text-wrap">
          <span class="error-title">Column Mapping Required</span>
          <span class="error-detail">{{ headerErrorMessage }}</span>
        </div>
      </div>
      <button type="button" *ngIf="isHeaderMappingRequired && sourceListData.length > 0"
        class="upload-modal-configure-btn" [disabled]="!sourcingListFileName"
        (click)="openHeaderMappingModal(mappingModal)" title="Configure field mappings">
        <i class="fa-solid fa-sliders"></i> Configure Mapping
      </button>
    </div>

    <!-- Modal Body -->
    <div class="upload-modal-body">
      <div class="upload-cards-grid">
        <!-- Card 1: Sourcing List (BOM) -->
        <div class="upload-card upload-card--sourcing" [class.upload-card--filled]="sourcingListFileName">
          <div class="upload-card-header">
            <div class="upload-card-header-left">
              <div class="upload-card-badge sky-badge">
                <i class="fa-solid fa-table-list"></i>
                <span>Step 1 &bull; Required</span>
              </div>
              <h6 class="upload-card-name">Sourcing List (BOM)</h6>
              <p class="upload-card-desc">Project BOM with customer &amp; internal part numbers</p>
            </div>
            <button type="button" class="upload-sample-pill sky-sample" (click)="sourcingData()"
              title="Download sample Sourcing List template">
              <i class="fa-solid fa-cloud-arrow-down"></i>
              <span>Sample .xlsx</span>
            </button>
          </div>

          <!-- Drop Area for Sourcing -->
          <div class="upload-drop-zone upload-drop-zone--sourcing" (click)="upload_input.click()"
            [class.drop-zone--has-file]="sourcingListFileName">
            <!-- Empty Drop State -->
            <div *ngIf="!sourcingListFileName" class="upload-drop-placeholder">
              <div class="upload-drop-icon-circle sky-circle">
                <i class="fa-solid fa-cloud-arrow-up"></i>
              </div>
              <span class="upload-drop-main-text">Drag &amp; drop BOM spreadsheet here</span>
              <span class="upload-drop-sub-text">or <span class="upload-browse-link">browse from computer</span></span>
              <div class="upload-format-chips">
                <span class="format-chip sky-chip"><i class="fa-solid fa-file-excel"></i> .XLSX</span>
                <span class="format-chip sky-chip"><i class="fa-solid fa-file-excel"></i> .XLS</span>
              </div>
            </div>

            <!-- Uploaded File State -->
            <div *ngIf="sourcingListFileName" class="upload-file-info">
              <div class="upload-file-icon-box file-excel-box">
                <i class="fa-solid fa-file-excel"></i>
              </div>
              <div class="upload-file-details">
                <span class="upload-file-name" title="{{ sourcingListFileName }}">{{ sourcingListFileName }}</span>
                <div class="upload-file-meta">
                  <span class="upload-file-status-pill success">
                    <i class="fa-solid fa-circle-check"></i> BOM Ready
                  </span>
                  <span class="upload-file-records-pill" *ngIf="sourceListData.length > 0">
                    <i class="fa-solid fa-cubes"></i> {{ sourceListData.length }} Parts loaded
                  </span>
                </div>
              </div>
              <div class="upload-file-actions">
                <button type="button" class="upload-change-file-btn"
                  (click)="$event.stopPropagation(); upload_input.click()" title="Replace file">
                  <i class="fa-solid fa-arrows-rotate"></i> Change
                </button>
                <button *ngIf="sourceListData.length > 0" type="button" class="upload-clear-btn"
                  (click)="$event.stopPropagation(); clearSourcingListFiles()" title="Remove file">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </div>
          </div>
          <input #upload_input type="file" class="file-input" hidden (change)="uploadSourcingListFiles($event)">
        </div>

        <!-- Card 2: Alternate Vendor List (AVD) -->
        <div class="upload-card upload-card--avd" [class.upload-card--filled]="alternatePartFileName">
          <div class="upload-card-header">
            <div class="upload-card-header-left">
              <div class="upload-card-badge slate-badge">
                <i class="fa-solid fa-layer-group"></i>
                <span>Step 2 &bull; Optional</span>
              </div>
              <h6 class="upload-card-name">Alternate Vendor List (AVD)</h6>
              <p class="upload-card-desc">Approved vendor cross-reference data or alternate quotes</p>
            </div>
            <button type="button" class="upload-sample-pill slate-sample" (click)="alternateData()"
              title="Download sample AVD template">
              <i class="fa-solid fa-cloud-arrow-down"></i>
              <span>Sample .xlsx</span>
            </button>
          </div>

          <!-- Drop Area for AVD -->
          <div class="upload-drop-zone upload-drop-zone--avd" (click)="upload_file_input.click()"
            [class.drop-zone--has-file]="alternatePartFileName">
            <!-- Empty Drop State -->
            <div *ngIf="!alternatePartFileName" class="upload-drop-placeholder">
              <div class="upload-drop-icon-circle slate-circle">
                <i class="fa-solid fa-cloud-arrow-up"></i>
              </div>
              <span class="upload-drop-main-text">Drag &amp; drop AVD file here</span>
              <span class="upload-drop-sub-text">or <span class="upload-browse-link">browse from computer</span></span>
              <div class="upload-format-chips">
                <span class="format-chip red-chip"><i class="fa-solid fa-file-pdf"></i> .PDF</span>
                <span class="format-chip sky-chip"><i class="fa-solid fa-file-excel"></i> .XLSX</span>
              </div>
            </div>

            <!-- Uploaded File State -->
            <div *ngIf="alternatePartFileName" class="upload-file-info">
              <div class="upload-file-icon-box file-pdf-box"
                [class.file-excel-box]="alternatePartFileName.endsWith('.xlsx') || alternatePartFileName.endsWith('.xls')">
                <i class="fa-solid"
                  [ngClass]="(alternatePartFileName.endsWith('.xlsx') || alternatePartFileName.endsWith('.xls')) ? 'fa-file-excel' : 'fa-file-pdf'"></i>
              </div>
              <div class="upload-file-details">
                <span class="upload-file-name" title="{{ alternatePartFileName }}">{{ alternatePartFileName }}</span>
                <div class="upload-file-meta">
                  <span class="upload-file-status-pill success">
                    <i class="fa-solid fa-circle-check"></i> AVD Ready
                  </span>
                  <span class="upload-file-records-pill" *ngIf="avdData.length > 0">
                    <i class="fa-solid fa-arrows-split-up-and-left"></i> {{ avdData.length }} Alternates loaded
                  </span>
                </div>
              </div>
              <div class="upload-file-actions">
                <button type="button" class="upload-change-file-btn"
                  (click)="$event.stopPropagation(); upload_file_input.click()" title="Replace file">
                  <i class="fa-solid fa-arrows-rotate"></i> Change
                </button>
                <button *ngIf="avdData.length > 0" type="button" class="upload-clear-btn"
                  (click)="$event.stopPropagation(); clearAvdFiles()" title="Remove file">
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </div>
            </div>
          </div>
          <input #upload_file_input type="file" accept=".pdf,.xlsx,.xls" class="file-input" hidden
            (change)="handleFileUpload($event)">
        </div>
      </div>

      <!-- Quick Manual Part Entry Banner -->
      <div class="upload-manual-shortcut-bar">
        <div class="manual-shortcut-content">
          <div class="manual-shortcut-icon">
            <i class="fa-solid fa-bolt"></i>
          </div>
          <div class="manual-shortcut-texts">
            <span class="manual-shortcut-title">If you want to add parts manually, you can add them here</span>
            <span class="manual-shortcut-subtitle">Directly enter internal part numbers, specifications, quantities, and
              sourcing criteria.</span>
          </div>
        </div>
        <button type="button" class="btn-manual-shortcut" (click)="navigateToAddPartManually()"
          title="Open Manual Part Entry Modal">
          <i class="fa-solid fa-plus"></i>
          <span>Add Part Manually</span>
        </button>
      </div>

      <!-- Mapping Modal (nested template) -->
      <ng-template #mappingModal let-modal>
        <div class="modal-header mapping-modal-header">
          <div class="d-flex align-items-center gap-2">
            <div class="mapping-icon-pill">
              <i class="fa-solid fa-sliders"></i>
            </div>
            <div>
              <h5 class="modal-title mb-0">Map Required Column Headers</h5>
              <small class="text-muted">Align spreadsheet headers with system fields</small>
            </div>
          </div>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mapping-modal-body">
          <div *ngIf="uploadedHeaders.length > 0" class="mapping-grid">
            <div *ngFor="let field of tableHeaders" class="mapping-row">
              <label class="mapping-label">
                <span class="mapping-field-title">{{ field.key === 'projectQty' ? 'Project qty' : field.label }}</span>
                <span class="mapping-field-key">{{ field.key }}</span>
              </label>
              <div class="mapping-select-col">
                <select class="form-select form-select-sm mapping-select" [(ngModel)]="reverseFieldMapping[field.key]"
                  name="{{field.key}}">
                  <option [ngValue]="null">-- Select Column from Upload --</option>
                  <option *ngFor="let header of uploadedHeaders" [value]="header">
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer mapping-modal-footer">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="modal.dismiss()">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" (click)="applyMappedData(); modal.close()">
            <i class="fa-solid fa-check"></i> Apply Mapping
          </button>
        </div>
      </ng-template>
    </div>

    <!-- Footer: Clean, Balanced Action Bar -->
    <div class="upload-modal-footer">
      <div class="upload-footer-left">
        <button type="button" class="upload-btn-secondary" (click)="closeUploadModal()">
          <i class="fa-solid fa-xmark"></i> Cancel
        </button>

        <!-- Utility Actions Pill Group -->
        <div class="upload-utility-group">
          <button type="button" class="upload-btn-utility" (click)="extractTechBomHistory()"
            [disabled]="isExtractingHistory" title="Extract Data from Input Source Details">
            <i class="fa-solid fa-database" *ngIf="!isExtractingHistory"></i>
            <span *ngIf="isExtractingHistory" class="spinner-border spinner-border-sm" role="status"></span>
            <span>Data Extract</span>
          </button>

          <button type="button" class="upload-btn-utility" (click)="fetchReleaseList()"
            [disabled]="isFetchingReleaseList" title="Fetch Released RFQ List from API">
            <i class="fa-solid fa-cloud-arrow-down" *ngIf="!isFetchingReleaseList"></i>
            <span *ngIf="isFetchingReleaseList" class="spinner-border spinner-border-sm" role="status"></span>
            <span>Get Released List</span>
          </button>

          <button type="button" class="upload-btn-utility upload-btn-utility--ai" (click)="toggleAiScrubbing()"
            title="Run AI-powered Scrubbing">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            <span>AI Scrubbing</span>
          </button>
        </div>
      </div>

      <div class="upload-footer-right">
        <button type="button" class="upload-btn-primary upload-btn-compare" (click)="finalData()" [disabled]="isLoading"
          title="Compare Sourcing List and Alternate Vendor Data">
          <i class="fa-solid fa-code-compare" *ngIf="!isLoading"></i>
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
          <span>Compare Both Files</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- AI Scrubbing Modal (opens on top of Upload Files popup) -->
<ng-template #aiScrubbingModal let-modal>
  <div class="upload-modal-header"
    style="background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%); border-bottom: 1px solid #c4b5fd;">
    <div class="upload-modal-header-left">
      <div class="upload-modal-icon-wrapper" style="background: linear-gradient(135deg, #7c3aed, #a855f7);">
        <i class="fa-solid fa-wand-magic-sparkles"></i>
      </div>
      <div>
        <h5 class="upload-modal-title">AI Scrubbing</h5>
        <p class="upload-modal-subtitle">Upload multiple source &amp; AVD files for AI processing</p>
      </div>
    </div>
    <button type="button" class="upload-modal-close" aria-label="Close" (click)="closeAiScrubbingModal()">
      <i class="nb-close"></i>
    </button>
  </div>

  <div class="ai-scrub-section" style="border-top: none;">
    <div class="ai-scrub-body">
      <!-- Source Files -->
      <div class="ai-scrub-card">
        <div class="ai-scrub-card-top">
          <div class="ai-scrub-card-label">
            <div class="ai-scrub-icon blue-bg"><i class="fa-solid fa-table-list"></i></div>
            <div>
              <span class="ai-scrub-card-title">Source Files</span>
              <span class="ai-scrub-card-hint">All file types supported</span>
            </div>
          </div>
          <label class="ai-scrub-browse-btn">
            <i class="fa-solid fa-plus" style="font-size: 11px;"></i> Add Files
            <input type="file" multiple hidden (change)="onAiSourceFilesSelected($event)">
          </label>
        </div>
        <div *ngIf="isAiSourceUploading" class="ai-scrub-uploading">
          <span class="spinner-border spinner-border-sm"></span> Uploading...
        </div>
        <div *ngIf="aiSourceFiles.length > 0" class="ai-scrub-file-list">
          <div *ngFor="let file of aiSourceFiles; let i = index" class="ai-scrub-file-item">
            <i class="fa-solid fa-file-excel ai-scrub-file-type-icon green-text"></i>
            <span class="ai-scrub-file-name">{{ file.name }}</span>
            <span class="ai-scrub-file-size">{{ (file.size / 1024).toFixed(0) }} KB</span>
            <button type="button" class="ai-scrub-file-remove" (click)="removeAiSourceFile(i)" title="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div *ngIf="aiSourceUploadedResponses.length > 0" class="ai-scrub-upload-status success">
          <i class="fa-solid fa-circle-check"></i> {{ aiSourceUploadedResponses.length }} file(s) uploaded
        </div>
      </div>

      <!-- AVD Files -->
      <div class="ai-scrub-card">
        <div class="ai-scrub-card-top">
          <div class="ai-scrub-card-label">
            <div class="ai-scrub-icon amber-bg"><i class="fa-solid fa-list-check"></i></div>
            <div>
              <span class="ai-scrub-card-title">AVD Files</span>
              <span class="ai-scrub-card-hint">All file types supported</span>
            </div>
          </div>
          <label class="ai-scrub-browse-btn">
            <i class="fa-solid fa-plus" style="font-size: 11px;"></i> Add Files
            <input type="file" multiple hidden (change)="onAiAvdFilesSelected($event)">
          </label>
        </div>
        <div *ngIf="isAiAvdUploading" class="ai-scrub-uploading">
          <span class="spinner-border spinner-border-sm"></span> Uploading...
        </div>
        <div *ngIf="aiAvdFiles.length > 0" class="ai-scrub-file-list">
          <div *ngFor="let file of aiAvdFiles; let i = index" class="ai-scrub-file-item">
            <i class="fa-solid fa-file ai-scrub-file-type-icon amber-text"></i>
            <span class="ai-scrub-file-name">{{ file.name }}</span>
            <span class="ai-scrub-file-size">{{ (file.size / 1024).toFixed(0) }} KB</span>
            <button type="button" class="ai-scrub-file-remove" (click)="removeAiAvdFile(i)" title="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div *ngIf="aiAvdUploadedResponses.length > 0" class="ai-scrub-upload-status success">
          <i class="fa-solid fa-circle-check"></i> {{ aiAvdUploadedResponses.length }} file(s) uploaded
        </div>
      </div>
    </div>

    <!-- AI Preview Table -->
    <div *ngIf="aiPreviewData.length > 0" class="ai-preview-table-wrap">
      <div class="ai-preview-table-header">
        <i class="fa-solid fa-table"></i>
        <span>Preview — {{ aiPreviewData.length }} rows | Columns: {{ aiPreviewColumns.length }}</span>
      </div>
      <div class="ai-preview-table-scroll">
        <table class="table table-striped custom-hover ai-preview-table">
          <thead>
            <tr>
              <th>#</th>
              <th *ngFor="let col of aiPreviewColumns">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of aiPreviewData; let i = index" [ngClass]="{'not-matched-row': row.isNotMatched}">
              <td>{{ i + 1 }}</td>
              <td *ngFor="let col of aiPreviewColumns">
                <ng-container *ngIf="col === 'EOL Status'; else plainCell">
                  <span [style.color]="row[col] === 'Active' ? '#16a34a' : '#dc2626'" style="font-weight: 600;">
                    {{ row[col] }}
                  </span>
                </ng-container>
                <ng-template #plainCell>{{ row[col] }}</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="upload-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeAiScrubbingModal()">
      <i class="fa-solid fa-arrow-left" style="font-size: 11px;"></i> Back
    </button>
    <button type="button" class="upload-btn-primary" (click)="processAiData()"
      [disabled]="isAiProcessing || (aiSourceUploadedResponses.length === 0 && aiAvdUploadedResponses.length === 0)">
      <span *ngIf="isAiProcessing" class="spinner-border spinner-border-sm" role="status"></span>
      <i *ngIf="!isAiProcessing" class="fa-solid fa-gears" style="font-size: 13px;"></i>
      Process Data
    </button>
  </div>
</ng-template>



<ng-template #criteriaModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper">
        <i class="fas fa-sliders-h"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Sourcing Criteria</h5>
        <p class="criteria-modal-subtitle">Configure ranking & filtering preferences</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="closeModal()">
      <i class="nb-close"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-check-double" style="color: #3b82f6; font-size: 13px;"></i>
        <span>Selection Criteria</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="criteria.stockAvailability">
          <input type="checkbox" [(ngModel)]="criteria.stockAvailability" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-warehouse" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Stock Availability</span>
            <span class="criteria-option-hint">Prefer in-stock parts</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="criteria.stockAvailability ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.leadTime">
          <input type="checkbox" [(ngModel)]="criteria.leadTime" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-shipping-fast" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Lead Time</span>
            <span class="criteria-option-hint">Prioritize faster delivery</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.leadTime ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.minimumPrice">
          <input type="checkbox" [(ngModel)]="criteria.minimumPrice" hidden />
          <div class="criteria-option-icon" style="background: rgba(245, 158, 11, 0.1);">
            <i class="fas fa-tags" style="color: #f59e0b;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Price</span>
            <span class="criteria-option-hint">Rank by lowest cost</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.minimumPrice ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.authorisedSuppliers">
          <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" hidden />
          <div class="criteria-option-icon" style="background: rgba(124, 58, 237, 0.1);">
            <i class="fas fa-shield-alt" style="color: #7c3aed;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Authorised Suppliers</span>
            <span class="criteria-option-hint">Only verified suppliers</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="criteria.authorisedSuppliers ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>

    <div class="criteria-section" style="margin-top: 14px;">
      <div class="criteria-section-label">
        <i class="fas fa-user-check" style="color: #7c3aed; font-size: 13px;"></i>
        <span>Supplier Selection</span>
      </div>
      <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" [multiple]="true" bindLabel="name"
        bindValue="name" class="custom-supplier-ng-select"
        [placeholder]="criteria.selectedSuppliers?.length ? '' : 'Search and select suppliers...'">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="custom-supplier-selected">{{ item.name }}</span>
          <i class="mdi mdi-close-circle-outline custom-supplier-clear-icon" (click)="clear(item)"></i>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="upload-btn-primary" (click)="saveModal()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save Criteria
    </button>
  </div>
</ng-template>

<!-- Modern Loading Overlay for Uploading & Sourcing -->
<div *ngIf="isUploading" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-cloud-upload sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">Sourcing & Upload in Progress</h4>
      <p class="sb-loading-subtitle">Processing BOM parts, validating MPNs, and running initial sourcing algorithms...</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>

<!-- MPN Alternatives Modal -->
<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showMpnAlternativesModal}"
  [ngStyle]="{'display': showMpnAlternativesModal ? 'block' : 'none', 'z-index': 1060}">
  <div class="modal-dialog" role="document" style="max-width: 900px; margin-top: 8vh;">
    <div class="modal-content date-filter-modal">
      <div class="date-filter-header">
        <div class="date-filter-header-left">
          <div class="date-filter-icon" style="background: linear-gradient(135deg, #7c3aed, #a855f7);">
            <i class="fa fa-microchip"></i>
          </div>
          <div>
            <div class="date-filter-title"> Part Check Result</div>
            <div class="date-filter-subtitle" *ngIf="selectedMpnResult">
              {{ selectedMpnResult.mpn }} —
              <span [style.color]="selectedMpnResult.eol_status === 'Active' ? '#16a34a' : '#dc2626'"
                style="font-weight:700;">
                {{ selectedMpnResult.eol_status }}
              </span>
              <span *ngIf="selectedMpnResult.eol_date"> | EOL Date: {{ selectedMpnResult.eol_date }}</span>
            </div>
          </div>
        </div>
        <button type="button" class="date-filter-close" (click)="closeMpnAlternativesModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="date-filter-body" style="padding: 0; max-height: 400px; overflow-y: auto;">
        <table class="table table-striped custom-hover" style="margin-bottom: 0;"
          *ngIf="selectedMpnResult?.alternatives?.length > 0">
          <thead>
            <tr>
              <th>MPN</th>
              <th>Manufacturer</th>
              <th>EOL Status</th>
              <th>EOL Date</th>
              <th>Reason</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let alt of selectedMpnResult.alternatives">
              <td>{{ alt.mpn }}</td>
              <td>{{ alt.manufacturer }}</td>
              <td>
                <span [style.color]="alt.eol_status === 'Active' ? '#16a34a' : '#dc2626'" style="font-weight: 600;">
                  {{ alt.eol_status }}
                </span>
              </td>
              <td>{{ alt.eol_date || '-' }}</td>
              <td style="max-width: 250px; white-space: normal; font-size: 11px;">{{ alt.reason }}</td>
              <td>
                <button class="btn btn-sm btn-primary" style="font-size: 11px; padding: 3px 10px;"
                  (click)="sendAlternativeToPreview(alt)">
                  <i class="fa fa-paper-plane" style="margin-right: 4px;"></i> Send
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!selectedMpnResult?.alternatives?.length"
          style="padding: 20px; text-align: center; color: #94a3b8;">
          No alternatives found.
        </div>
      </div>

      <div class="date-filter-footer">
        <button type="button" class="date-filter-btn-close" (click)="closeMpnAlternativesModal()">
          <i class="fa fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ...existing code... -->
<div class="modal-backdrop fade show" *ngIf="showMpnAlternativesModal" style="z-index: 1055;"></div>

<!-- Modern Loading Overlay for Project Refresh -->
<div *ngIf="isRefresh" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-refresh sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">Refreshing Projects</h4>
      <p class="sb-loading-subtitle">Fetching latest project records, version details, and status updates...</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>

<ng-template #dataPrefModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header"
    style="background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%); border-bottom: 1px solid #fed7aa;">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper" style="background: linear-gradient(135deg, #f59e0b, #d97706);">
        <i class="fas fa-database"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Data Preference</h5>
        <p class="criteria-modal-subtitle">Choose sourcing data sources</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="nb-close"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-layer-group" style="color: #f59e0b; font-size: 13px;"></i>
        <span>Source Type</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('nexar')">
          <input type="checkbox" [checked]="dataPreference.includes('nexar')"
            (change)="onDataPrefChange('nexar', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-globe" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Consolidator</span>
            <span class="criteria-option-hint">Online marketplace data</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="dataPreference.includes('nexar') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('vendor')">
          <input type="checkbox" [checked]="dataPreference.includes('vendor')"
            (change)="onDataPrefChange('vendor', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-handshake" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Direct</span>
            <span class="criteria-option-hint">Direct vendor sourcing</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="dataPreference.includes('vendor') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
    <button type="button" class="upload-btn-primary" (click)="saveDataPreference()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save Preference
    </button>
  </div>
</ng-template>